import React, { Component } from "react";
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";

export default class ProductSelect extends Component {
	render () {
		const sections = this.props.item.variation.map((variation,i) =>
			<Link to={{ pathname: variation.slug }} key={i} className="c-product__select__option">
				{variation.swatch_src && 
					<div className={'c-product__select__option__inner ' + (this.props.item.selected_variation == variation.slug ? 'state-active' : 'state-inactive')}>
						<FadeIn duration={250}>
							{onload => (
								<img
									alt={variation.name} 
									src={variation.swatch_src} 
									onLoad={onload}
								/>
							)}
						</FadeIn>
					</div>
				}
				{variation.swatch_hex &&
					<div className={'c-product__select__option__inner ' + (this.props.item.selected_variation == variation.slug ? 'state-active' : 'state-inactive')} style={{backgroundColor: variation.swatch_hex}}></div>
				}
				<p className="c-product__select__option__text">{ variation.name }</p>
			</Link>
		);
		return (
			<div className="c-product__select">
				<p className="c-product__select__text">Colour/Finish Options</p>
				{ sections }
			</div>
		);
	}
}